import React, { useEffect } from 'react';

type FormPromptProps = {
  hasUnsavedChanges: boolean;
};

export const FormPrompt = ({ hasUnsavedChanges }: FormPromptProps) => {
  useEffect(() => {
    const onBeforeUnload = (e: any) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return <></>;
};
